/**
 * BroadcastChrome — the permanent broadcast frame (SEASON ONE Loop 0 spine;
 * ported from the prototype's .bcast/.bug/.prize/.ticker). LIVE bug (red dot +
 * label), prize bug (gold amount — the earned surface), and the bottom Ticker
 * (volt LIVE label + scrolling track). Clip-path bevels per tokens throughout.
 * The prototype ticker's backdrop-filter is dropped (glassmorphism ban) — the
 * fill is solid derived rgba.
 */

export interface TickerProps {
  /** Ticker feed lines. The track is rendered twice for a seamless -50% loop. */
  items: string[];
  /** The volt label chip. Default "LIVE". */
  label?: string;
  className?: string;
}

export function Ticker({ items, label = "LIVE", className }: TickerProps) {
  const copy = (hidden: boolean) => (
    <span className="mdui-ticker-copy" {...(hidden ? { "aria-hidden": true } : {})}>
      {items.map((t, i) => (
        <span className="mdui-ticker-item" key={i}>
          {t}
        </span>
      ))}
    </span>
  );

  return (
    <div className={["mdui-ticker", className].filter(Boolean).join(" ")}>
      <div className="mdui-ticker-label">{label}</div>
      <div className="mdui-ticker-viewport">
        {/* duplicated track: second copy is aria-hidden; -50% translate loops
            seamlessly because each copy carries its own trailing gap.
            Pauses entirely under prefers-reduced-motion (ui.css). */}
        <div className="mdui-ticker-track">
          {copy(false)}
          {copy(true)}
        </div>
      </div>
    </div>
  );
}

import { TabularDigits } from "./TabularDigits";

export interface BroadcastChromeProps {
  /** LIVE bug label. Default "GAMES NIGHT · LIVE". */
  liveLabel?: string;
  /** Prize pool amount, e.g. "R5,000". Omitting it omits the prize bug. */
  prizeAmount?: string;
  /** Prize bug caption. Default "Prize Pool". */
  prizeLabel?: string;
  /** Ticker feed; omit or pass empty to render the top chrome only. */
  tickerItems?: string[];
  className?: string;
}

export function BroadcastChrome({
  liveLabel = "GAMES NIGHT · LIVE",
  prizeAmount,
  prizeLabel = "Prize Pool",
  tickerItems,
  className,
}: BroadcastChromeProps) {
  return (
    <>
      <div className={["mdui-bcast", className].filter(Boolean).join(" ")}>
        <div className="mdui-bug">
          <span className="mdui-bug-dot" aria-hidden="true" />
          <b className="mdui-bug-label">{liveLabel}</b>
        </div>
        {prizeAmount != null ? (
          <div className="mdui-prize">
            <div className="mdui-prize-amount">
              <TabularDigits value={prizeAmount} />
            </div>
            <div className="mdui-prize-label">{prizeLabel}</div>
          </div>
        ) : null}
      </div>
      {tickerItems && tickerItems.length > 0 ? <Ticker items={tickerItems} /> : null}
    </>
  );
}
